export default __webpack_public_path__ + "static/media/react.4ee8d000.svg";